export const css = {
	root: '_3Hu-6L1Z',
	content: '_1h9YrOqY',
	about: '_38WC4sRv',
	button: '_39yOM8D3',
	remind: '_26RgzM0o',
	scoreBlock: '_2cCvuNRt',
	scores: 'NmSJ-EGV',
	retake: '_2acfP0qM',
	scoreTitle: '_1zWE7_jS',
	scoreValue: '_15OHFNgZ',
	assessExtra: 'ErxaquWi',
	scoreBlockTitle: '_3a-_-daW',
	lockIcon: '_1sfnrpW-',
	' _key': 'explore-view/assess-view'
};

export default css;
